// src/utils/publicRoutes.js
// รายการหน้าที่เปิดให้เข้าชมได้โดยไม่ต้องเข้าสู่ระบบ ใช้สำหรับจัดกลุ่มสถิติการเข้าถึงเว็บไซต์
// หมายเหตุ: /dashboard, /profile และ /farmerprofile ถูกประกาศไว้นอก RequireAuth ใน App.js
// แต่ใช้งานได้เฉพาะผู้ที่เข้าสู่ระบบแล้ว จึงไม่นับเป็นหน้าสาธารณะ
export const PUBLIC_ROUTES = [
  "/",
  "/login",
  "/loginstaff",
  "/verify-email",
  "/home",
  "/newsdetail",
  "/mapofficelocation",
  "/mapoffice",
  "/distributionpoint",
  "/registrationfarmer",
  "/registrationofficestaff",
  "/vaccineinfo",
  "/diseaseinfo",
  "/webcontentepidemic",
  "/vaccineusageoverview",
  "/livestockamountoverview",
];

const publicRouteSet = new Set(PUBLIC_ROUTES);

export const isPublicPath = (pathname) => {
  if (!pathname) return false;
  const normalized =
    pathname.length > 1 ? pathname.toLowerCase().replace(/\/+$/, "") : "/";
  return publicRouteSet.has(normalized);
};
